<!--
    Desarrollado por: Wuilmer garcia
    // Fecha: 2022/05/30
    // Modificado por: 
    // Fecha de ultima Modificacion:    
    // Causa: 

    ///////////////////////////////////////////////////////////
-->  
<template>
    <div>
        <!-- Agregar PreguntaS -->

        <v-alert type="error" v-if="errorTema" class="mt-2">{{ menssageError }}</v-alert>

        <v-form ref="formdatos" lazy-validation>
            <ComunDialogComp v-model="estadoComp" max-width="600px" :title="formTitle" @close-modal="closeComp()">
                <template v-slot:body>
                    <v-row>
                        <v-col cols="12" sm="12" md="6" class="py-0">
                            <v-select v-model="datos.id_pais" :items="listPais" label="País" item-value="id"
                                item-text="nombre_pais" @change="GetNivelGrado(datos.id_pais)" :disabled="disabledPais"
                                :rules="[rul.selectReq]">
                            </v-select>
                        </v-col>


                        <v-col cols="12" sm="12" md="6" class="py-0">
                            <v-select v-model="datos.id_grado" :items="listGrado" label="Grado" item-value="id"
                                item-text="grado_nivel" @change="GetArea(datos.id_grado)" :disabled="disabledGrado"
                                :rules="[rul.selectReq]">
                            </v-select>
                        </v-col>


                        <v-col cols="12" sm="12" md="6" class="py-0">
                            <v-select v-model="datos.id_area" :items="listArea" label="Área" item-value="id"
                                item-text="desc_area" @change="GetCurso(datos.id_area)" :disabled="disabledArea"
                                :rules="[rul.selectReq]">
                            </v-select>
                        </v-col>

                        <v-col cols="12" sm="12" md="6" class="py-0">
                            <v-select v-model="datos.id_curso" :items="listCurso" label="Curso" item-value="id"
                                item-text="desc_curso" :disabled="disabledCurso" :rules="[rul.selectReq]">
                            </v-select>
                        </v-col>

                        <v-col cols="12" sm="12" md="6" class="py-0">
                            <v-text-field v-model="datos.nombre_tema" label="Unidad" :rules="[rul.required]"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="6" class="py-0">
                            <v-text-field v-model="datos.orden" label="Orden" type="number" min="0"
                                @keypress="soloNumeros($event)"></v-text-field>
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:actions>
                    <v-spacer></v-spacer>
                    <ButtonComp @click="saveItem()" :disabled="loading"
                        :text-button="parametros.evento == 'edit' ? 'Guardar cambios' : 'Guardar'" iconBut="fas fa-save"
                        normal-button />
                    <ButtonComp @click="$emit('close')" :disabled="loading" textButton="Cancelar" classColor="red"
                        normal-button class="mx-2" />
                </template>
            </ComunDialogComp>


        </v-form>

        <!-- fin modal Pregunta -->


    </div>
</template>

<script>


import axios, { API_URL } from "@/helpers/axios"
// import BtnComp from "@/components/ComponentsEst/BtnComp.vue";
import { mapGetters, mapMutations } from 'vuex';
import ComunDialogComp from '../../../../../components/ComponentsEst/ComunDialogComp.vue';
import ButtonComp from '../../../../../components/ComponentsEst/TableButtonComp.vue';


export default {
    name: 'UnidadFormulario',
    components: {
        // BtnComp,
        ButtonComp,
        ComunDialogComp
    },


    props: {
        parametros: {
            type: Object
        },
        estadoComp: {
            type: Boolean
        },
    },


    data: () => ({

        datoLogin: sessionStorage,
        evento: null,
        test: false,
        datos: {},
        paramComponente: { 'id_submodulo': 22, "id_modulo": 4 },


        errorTema: false,

        rutaServer: API_URL,
        inhabilitarButton: false,

        filter: {},
        loading: false,

        disabledPais: true,
        disabledArea: true,
        disabledCurso: true,
        disabledGrado: true,


        listPais: [],
        listGrado: [],
        listArea: [],
        listCurso: [],


        //validaciones de formulario
        rul: {
            required: value => !!value || 'Campo Requerido',
            inputReq: value => !!value || 'Campo Requerido',
            selectReq: value => !!value || 'Debe seleccionar un campo de la lista',
            email: value => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) || 'El correo Electrónico es incorrecto',
            min4: v => (v || '').length >= 4 || 'Mínimo 4 caracteres',
            min6: v => (v || '').length >= 6 || 'Mínimo 6 caracteres',
            min8: v => (v || '').length >= 8 || 'Mínimo 8 caracteres',
            max10: v => (v || '').length <= 10 || 'Máximo 10 caracteres',
            max11: v => (v || '').length <= 11 || 'Máximo 11 caracteres',
            max12: v => (v || '').length <= 12 || 'Máximo 12 caracteres',
            max20: v => (v || '').length <= 20 || 'Máximo 20 caracteres',
            max30: v => (v || '').length <= 30 || 'Máximo 30 caracteres',
            max40: v => (v || '').length <= 40 || 'Máximo 40 caracteres',
            max50: v => (v || '').length <= 50 || 'Máximo 50 caracteres',
            max60: v => (v || '').length <= 60 || 'Máximo 60 caracteres',
            max100: v => (v || '').length <= 100 || 'Máximo 100 caracteres',
            max150: v => (v || '').length <= 150 || 'Máximo 150 caracteres',

            email_null: value => {
                if (value == '') {
                    return false
                }
                else {
                    const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
                    return pattern.test(value) || 'El correo Electrónico es incorrecto'
                }
            },

            hora: value => {
                if (value < '00:01') {
                    return 'El formato de la hora ingresada es incorrecto'
                }
                else {
                    if (value >= '23:59') {
                        return 'El formato de la hora ingresada es incorrecto'
                    }
                }
            },
        },

    }),

    mounted() {
        this.loadMain()
    },

    //computadas
    computed: {

        ...mapGetters('login', ['componenteEvento']),

        formTitle() {
            return this.parametros.evento === 'add' ? 'Crear unidad' : 'Editar unidad'
        },



    },


    watch: {
        // cada vez que la pregunta cambie, esta función será ejecutada
        estadoComp() {

            if (this.estadoComp) {
                this.loadMain()
            } else {
                //this.parametros = {}
                this.limpiarForm()

            }
        }
    },

    methods: {

        //  ------- MENSAJE DE SISTEMA  --------

        ...mapMutations('mensajeSis', ['setEnviarMens']),

        soloNumeros(event) {
            var key = window.event ? event.which : event.keyCode;
            if (key < 48 || key > 57) {
                event.preventDefault();
            }
        },


        loadMain() {
            console.log("load Main (UnidadForm)")
            console.log(`Evento: ${JSON.stringify(this.parametros)} `)
            this.limpiarForm()


            this.getPais()

            if (this.parametros.evento == 'add') {
                this.disabledPais = false
            }

            if (this.parametros.evento == 'edit') {
                this.editItem(this.parametros.item)
            }

            if (this.parametros.evento == 'view') {
                this.editItem(this.parametros.item)
            }

        },

        async editItem(items) {
            this.disabledPais = true
            this.disabledGrado = true
            this.disabledArea = true
            this.disabledCurso = true

            this.datos = items
            this.datos.id_usuario = sessionStorage.id


            this.GetNivelGrado(null)
            this.GetArea(null)
            this.GetCurso()



        },


        async getPais() {
            try {
                let response = await axios.get('/manager/pais/');
                this.listPais = response.data
            } catch (error) {
                console.log(error);
            }
        },

        ////////////// TRAER GRADOS PARA CREAR TEMAS //////////////
        async GetNivelGrado(id) {

            try {

                const response = await axios.get(`manager/gradoCkOne/nivelGrado/pais/${id}`);
                this.listGrado = response.data
                //console.log(this.listTemaGrado)
                this.disabledGrado = this.listGrado.length > 0 ? false : true;
            } catch (e) {
                console.log(e)
            }
        },


        ////////////////////////////////////////////////////////////////////
        //////////////TRAER LOS AREAS X el nivel - grado seleccionado  /////
        async GetArea(id) {

            let datosFiltrado = this.listGrado.filter(e => e.id == id)
            this.datos.id_nivel = datosFiltrado[0].id_nivel
            console.log(`Nivel:${this.datos.id_nivel}, Grado : ${id}`)

            try {
                const response = await axios.get(`manager/areaCkOne/nivel/${this.datos.id_nivel}`)
                this.listArea = response.data
                this.disabledArea = this.listArea.length > 0 ? false : true;

            } catch (e) {
                console.log(e)
            }
        },

        ////////////////////////////////////////////////////////////
        //////////////TRAER LOS CURSOS PARA CREAR TEMA /////////////
        async GetCurso() {
            try {
                const response = await axios.post(`/manager/cursoCkOne/cursos/`, this.datos);
                // const response = await axios.get(`/manager/cursoCkOne/cg/list/${id}`);
                this.listCurso = response.data
                this.disabledCurso = this.listCurso.length > 0 ? false : true;
            } catch (error) {
                console.log(error);
            }
        },

        // Guardar datos
        async saveItem() {

            if (this.$refs.formdatos.validate() == false) {
                this.setEnviarMens({ tipo: "E", mensaje: "Debe completar todos los campos requeridos.", tiempo: 5000 })
                return false
            }
            this.loading = true;

            try {

                let res = ""

                if (this.parametros.evento == 'add') {

                    res = await axios.post(`/manager/tema/`, this.datos)
                    this.setEnviarMens({ tipo: res.messageT, mensaje: `${res.message}`, tiempo: null })

                }

                if (this.parametros.evento == 'edit') {

                    res = await axios.put(`/manager/tema/${this.datos.id}`, this.datos)

                }


                this.setEnviarMens({ tipo: `${res.data.messageT}`, mensaje: `${res.data.message}`, tiempo: 6000 })
                this.inhabilitarButton = false
                this.loading = false;

                if (res.data.messageT == "S") {
                    this.$emit('close')
                }

            }
            catch (error) {

                this.inhabilitarButton = false
                //console.log(handleError(error))
                //console.log(error) 
                this.loading = false;
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }



        },




        resetValidation() {
            this.$refs.formdatos.resetValidation()
        },


        closeComp() {

            console.log("close componente (preguntaFomComp) ")
            this.estadoModalConfig = false
            this.compName = null
            this.$emit('close')
        },


        limpiarForm() {
            //    num_documento:77889966, num_documento2:55887745,                
            this.datos = {
                id_us_ing: sessionStorage.id,
                id_us_mod: null,
                fec_us_mod: null,
                estado_tema: 1,
                nombre_tema: '',
                id_pais: 0,
                id_nivel: 0,
                id_grado: null,
                id_area: null,
                id_curso: null,
                flag_malla_curricular: 1,
                id_usuario: sessionStorage.id,
                orden: null


            }



            this.resetValidation()

        },


    },
}
</script>
<style scoped></style>